// @ts-nocheck
import * as React from "react";
import Drawer from "@mui/material/Drawer";
import { useLanguage } from "../LanguageContext";
import { useMediaQuery, useTheme } from "@mui/material";
import Header from "./Header";
import ThemeToggle from "../userDrawer/themeToggle";

const languages = [
  "cz",
  "en",
  "fr",
  "es",
  "nl",
  "sk",
  "de",
  "hu",
  "pl",
  "ru",
  "sv",
  "no",
  "fi",
  "da",
  "ar",
];

interface LanguageDrawerProps {
  open: boolean;
  onClose: () => void;
}

const LanguageDrawer: React.FC<LanguageDrawerProps> = ({ open, onClose }) => {
  const theme = useTheme();
  const { setLanguage } = useLanguage();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const handleLanguageChange = (lang: string) => {
    setLanguage(lang);
    onClose();
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      BackdropProps={{
        sx: {
          backgroundColor: "rgba(88, 110, 223, .8)",
        },
      }}
      PaperProps={{
        sx: {
          width: isSmallScreen ? "100%" : 380,
          minWidth: 320,
          borderTopLeftRadius: 16,
          borderBottomLeftRadius: 16,
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          overflow: "hidden",
        },
      }}
    >
      <div className="bg-white dark:bg-darkSecondaryBackground h-screen flex flex-col">
        <div className="z-30 relative">
          <div className="absolute right-2 top-4 z-40" onClick={onClose}>
            <ThemeToggle />
          </div>
          <Header hideLanguageFlag={true} />
        </div>
        <div className="flex-1 p-4">
          <p className="px-2 text-xs uppercase tracking-wider text-gray-500 dark:text-white mb-4">
            Select Language
          </p>
          <div className="flex flex-wrap gap-3 justify-center">
            {languages.map((lang) => (
              <button
                key={lang}
                onClick={() => handleLanguageChange(lang)}
                className="p-3 rounded-lg bg-white shadow-sm dark:bg-darkBackground/60 border border-transparent dark:border-purple/30 hover:shadow-md dark:hover:bg-darkBackground/70 transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-purple/50"
              >
                <img
                  src={`/flags/${lang}.png`}
                  alt={lang}
                  className="h-6 w-auto"
                />
              </button>
            ))}
          </div>
        </div>
      </div>
    </Drawer>
  );
};

export default LanguageDrawer;
